module.exports = __webpack_public_path__ + "img/Lipalink-Logo-white.29c1e3eb.png";